// extracted by mini-css-extract-plugin
module.exports = {"offerProductItem":"OfferTile_offerProductItem__OLcDJ","btnContainer":"OfferTile_btnContainer__uEgA_"};